module.exports = __webpack_public_path__ + "static/media/check_with_bg_black.bbf5579f.svg";